/*
 * Proprietary and confidential | 2026 | SoundTalks NV
 */

import { fromJS } from 'immutable';
import * as constants from 'data/constants/admin/escalation-policies';
import LoadingProgress from 'data/utils/reducers/loading';
import Pagination from 'data/utils/reducers/pagination';

export const itemsPagination = new Pagination('adminEscalationPolicies');
export const listLoadingProgress = new LoadingProgress('adminEscalationPoliciesList');
export const loadingProgress = new LoadingProgress('adminEscalationPolicy');
export const createLoadingProgress = new LoadingProgress('adminEscalationPolicyCreate');
export const updateLoadingProgress = new LoadingProgress('adminEscalationPolicyUpdate');

const loadList = (state: any, action: any) =>
  state.withMutations((newState: any) => {
    const { items, total, perPage } = action.payload;
    itemsPagination.set(newState, total, perPage, fromJS(items));
    listLoadingProgress.setLoaded(newState);
  });

const loadSingle = (state: any, action: any) =>
  state.withMutations((newState: any) => {
    newState.set('current', fromJS(action.payload));
    loadingProgress.setLoaded(newState);
  });

const clear = (state: any) =>
  state.withMutations((newState: any) => {
    itemsPagination.clear(newState);
    listLoadingProgress.clear(newState);
    createLoadingProgress.clear(newState);
  });

const clearSingle = (state: any) =>
  state.withMutations((newState: any) => {
    newState.delete('current');
    loadingProgress.clear(newState);
    updateLoadingProgress.clear(newState);
  });

const initialState = fromJS({});

export default (state = initialState, action: any) => {
  switch (action.type) {
    case constants.LIST_LOAD_START:
      return listLoadingProgress.setLoading(state);
    case constants.LIST_LOAD_FAILED:
      return listLoadingProgress.setLoadFailed(state);
    case constants.LIST_LOAD_SUCCESS:
      return loadList(state, action);
    case constants.LOAD_START:
      return loadingProgress.setLoading(state);
    case constants.LOAD_FAILED:
      return loadingProgress.setLoadFailed(state);
    case constants.LOAD_SUCCESS:
      return loadSingle(state, action);
    case constants.CREATE_START:
      return createLoadingProgress.setLoading(state);
    case constants.CREATE_FAILED:
      return createLoadingProgress.setLoadFailed(state);
    case constants.CREATE_SUCCESS:
      return createLoadingProgress.setLoaded(state);
    case constants.UPDATE_START:
      return updateLoadingProgress.setLoading(state);
    case constants.UPDATE_FAILED:
      return updateLoadingProgress.setLoadFailed(state);
    case constants.UPDATE_SUCCESS:
      return state.withMutations((newState: any) => {
        newState.set('current', fromJS(action.payload));
        updateLoadingProgress.setLoaded(newState);
      });
    case constants.CLEAR:
      return clear(state);
    case constants.CLEAR_SINGLE:
      return clearSingle(state);
    default:
      return state;
  }
};
